import cloneDeep from 'lodash.clonedeep';
import { v4 as uuid } from 'uuid';

import { projectsActionCreators } from 'src/actions/projects/actionCreators';
import { createDraftData } from 'src/containers/ProjectDiagram/utils/draft/createDraftData';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';
import { createVoiceboxModel } from 'src/utils/voicebox/createVoiceboxModel';
import { fixTurtle } from 'src/utils/voicebox/parsing/fixTurtle';

// TODO can't use createAsyncThunk and .pending because this creates a circular
// dependency on ui.slice -> (this file) -> ui.slice
export const addVoiceboxModel =
  ({ code, projectId }: { code: string; projectId: string }) =>
  (dispatch: AppDispatch, getState: ReduxStateGetter) => {
    projectsActionCreators.addVoiceboxModelToProjectAttempt(projectId);

    const { projects } = getState();
    const project = projects.projectsById[projectId];
    if (!project) {
      console.warn('!project');
      return false;
    }

    if (!project.diagram.model.modelData.draftData) {
      const updatedModel = cloneDeep(project.diagram.model);
      updatedModel.modelData.draftData = createDraftData(updatedModel);

      dispatch(
        projectsActionCreators.updatedProjectDiagram(projectId, {
          id: uuid(),
          model: updatedModel,
        })
      );
    }

    const fixedCode = fixTurtle(code);
    const projectModel = createVoiceboxModel(fixedCode);
    if (!projectModel) {
      projectsActionCreators.addVoiceboxModelToProjectFailure(projectId);

      return false;
    }

    dispatch(
      projectsActionCreators.addVoiceboxModelToProjectSuccess(
        projectId,
        projectModel
      )
    );

    return true;
  };
